import styled from 'styled-components'

import { btnSecondaryBg, cmsContentBg, cmsContentColor } from '../../../../../utils/style-utils'

const TriangularSize = '4rem'

const Wrapper = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: ${TriangularSize};
  height: ${TriangularSize};

  div {
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;
    z-index: 2;
  }

  svg {
    height: 1.5rem;
    width: 1.5rem;
    fill: ${cmsContentBg};
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    z-index: 1;
    border-style: solid;
    border-width: ${TriangularSize} ${TriangularSize} 0 0;
    border-color: ${cmsContentColor} transparent transparent transparent;
  }
`

const WrapperRightTop = styled(Wrapper)`
  right: 0;
  left: initial;

  div {
    left: initial;
    right: 0.3rem;
  }

  &::after {
    border-width: ${TriangularSize};
    border-color: ${btnSecondaryBg} transparent transparent transparent;
  }
`

export const Wrappers = {
  'left-top': Wrapper,
  'right-top': WrapperRightTop,
}
